import { render } from "./bfbbb.vue?vue&type=template&id=0fd0e608&scoped=true&ts=true"
import script from "./bfbbb.vue?vue&type=script&lang=ts"
export * from "./bfbbb.vue?vue&type=script&lang=ts"

import "./bfbbb.vue?vue&type=style&index=0&id=0fd0e608&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd0e608"]])

export default __exports__